export var GET_QUESTION_LIST = 'GET_QUESTION_LIST';
export var GET_QUESTION_LIST_NEW = 'GET_QUESTION_LIST_NEW';
export var QUESTION_LIST = 'QUESTION_LIST';
export var SUBMIT_ANSWER = 'SUBMIT_ANSWER';
export var SUBMIT_ANSWER_NEW = 'SUBMIT_ANSWER_NEW';
export var ANSWER_RESULT = 'ANSWER_RESULT';
export var TOGGLE_NEW_MODAL = 'TOGGLE_NEW_MODAL';